import type { LoyaltyProgramme } from "../types";

// The Lufthansa Group programme collects the card number only; the API shows
// no amounts for it, so the unit words are never rendered.
const UNIT = { singular: "mile", plural: "miles" };

/**
 * Miles & More as the Lufthansa Group sites present it. The field label per
 * locale is the one the old microsites shipped (their approved translations);
 * the site default locale covers any other locale.
 */
export const MILES_AND_MORE: LoyaltyProgramme = {
  code: "MILES_AND_MORE",
  text: {
    "da-DK": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More-kortnummer" },
      },
    },
    "de-DE": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More Kartennummer" },
      },
    },
    "en-GB": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More card number" },
      },
    },
    "en-IE": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More card number" },
      },
    },
    "en-US": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More card number" },
      },
    },
    "es-ES": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Número de tarjeta Miles & More" },
      },
    },
    "fr-FR": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Numéro de carte Miles & More" },
      },
    },
    "fr-MA": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Numéro de carte Miles & More" },
      },
    },
    "is-IS": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More kortanúmer" },
      },
    },
    "it-IT": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: {
          label: "Numero della carta Miles & More",
        },
      },
    },
    "ms-MY": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Nombor kad Miles & More" },
      },
    },
    "nb-NO": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More kortnummer" },
      },
    },
    "pl-PL": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Numer karty Miles & More" },
      },
    },
    "pt-PT": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Número do cartão Miles & More" },
      },
    },
    "sv-SE": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More-kortnummer" },
      },
    },
    "th-TH": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "หมายเลขบัตร Miles & More" },
      },
    },
    "tr-TR": {
      name: "Miles & More",
      unit: UNIT,
      fields: {
        miles_and_more_card_number: { label: "Miles & More kart numarası" },
      },
    },
    "zh-CN": {
      name: "Miles & More",
      unit: UNIT,
      fields: { miles_and_more_card_number: { label: "Miles & More 卡号" } },
    },
  },
};
